/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ForReviewQueueRoute_query = {
    readonly flags: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly " $fragmentRefs": FragmentRefs<"ForReviewQueueRowContainer_flag">;
            };
        }>;
    };
    readonly viewer: {
        readonly id: string;
    } | null;
    readonly settings: {
        readonly forReviewQueue: boolean;
    };
    readonly " $refType": "ForReviewQueueRoute_query";
};
export type ForReviewQueueRoute_query$data = ForReviewQueueRoute_query;
export type ForReviewQueueRoute_query$key = {
    readonly " $data"?: ForReviewQueueRoute_query$data;
    readonly " $fragmentRefs": FragmentRefs<"ForReviewQueueRoute_query">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [
            {
                "defaultValue": 15,
                "kind": "LocalArgument",
                "name": "count"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cursor"
            },
            {
                "defaultValue": "CREATED_AT_DESC",
                "kind": "LocalArgument",
                "name": "orderBy"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "section"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "siteID"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "storyID"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "count",
                    "cursor": "cursor",
                    "direction": "forward",
                    "path": [
                        "flags"
                    ]
                }
            ]
        },
        "name": "ForReviewQueueRoute_query",
        "selections": [
            {
                "alias": "flags",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "orderBy",
                        "variableName": "orderBy"
                    },
                    {
                        "kind": "Variable",
                        "name": "section",
                        "variableName": "section"
                    },
                    {
                        "kind": "Variable",
                        "name": "siteID",
                        "variableName": "siteID"
                    },
                    {
                        "kind": "Variable",
                        "name": "storyID",
                        "variableName": "storyID"
                    }
                ],
                "concreteType": "FlagsConnection",
                "kind": "LinkedField",
                "name": "__ForReviewQueue_flags_connection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlagEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Flag",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "__typename",
                                        "storageKey": null
                                    },
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "ForReviewQueueRowContainer_flag"
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cursor",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endCursor",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasNextPage",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "viewer",
                "plural": false,
                "selections": [
                    (v0 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Settings",
                "kind": "LinkedField",
                "name": "settings",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "forReviewQueue",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Query",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '1c64d72b48bcbd566e49684c0c1a26c1';
export default node;
